import {
  ENTITY_SUMMARY_FETCH_REQUEST,
  ENTITY_SUMMARY_FETCH_REQUEST_SUCCESS,
  ENTITY_SUMMARY_FETCH_REQUEST_FAILURE,
  ENTITY_SUMMARY_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const entitySummariesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case ENTITY_SUMMARY_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case ENTITY_SUMMARY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case ENTITY_SUMMARY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case ENTITY_SUMMARY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default entitySummariesReducer;
